"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRevieveAdvisor = void 0;
var _react = require("react");
var _utils = require("../utils");
const useRevieveAdvisor = ({
  clear
}) => {
  const reset = (0, _react.useCallback)(config => {
    (0, _utils.unmountRevieve)();
    clear();
    (0, _utils.initRevieve)(config);
  }, [clear]);
  return (0, _react.useMemo)(() => ({
    close: _utils.hideRevieve,
    open: _utils.showRevieve,
    reset
  }), [reset]);
};
exports.useRevieveAdvisor = useRevieveAdvisor;